export enum LeakDetectionMode {
  LeakScore = 'LEAK_SCORE',
  LeakAiPredictor = 'LEAK_AI_PREDICTOR',
}
